<template>
  <svg
    width="50"
    height="24"
    viewBox="0 0 50 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.5839 6.14844H33.688V17.9428H37.6028V14.297H42.2772V10.9853H37.6028V9.5473H42.5839V6.14844Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M49.8618 17.9401V12.6094H44.6323V17.9401H49.8618Z"
      fill="white"
    />
    <path
      d="M28.4415 23.4453H28.3184V19.9071V6.93782V0.570795H28.4415V1.89093V13.7889V23.4453Z"
      fill="white"
    />
    <path d="M14.6496 17.584H8.46045V6.43229H14.6496V17.584Z" fill="#F26521" />
    <path
      d="M8.85365 12.0084C8.85365 9.74597 9.91019 7.73119 11.5552 6.43253C10.3521 5.48277 8.83395 4.91618 7.18402 4.91618C3.2778 4.91618 0.111328 8.09151 0.111328 12.0084C0.111328 15.9252 3.2778 19.1006 7.18402 19.1006C8.83395 19.1006 10.3521 18.534 11.5552 17.5842C9.91019 16.2856 8.85365 14.2708 8.85365 12.0084Z"
      fill="#E51B24"
    />
    <path
      d="M22.7786 16.4023V16.1271H22.7068L22.6245 16.3164L22.542 16.1271H22.4702V16.4023H22.5209V16.1947L22.5981 16.3736H22.6507L22.7279 16.1941V16.4023H22.7786ZM22.3247 16.4023V16.174H22.4165V16.1275H22.1826V16.174H22.2744V16.4023H22.3247Z"
      fill="white"
    />
    <path
      d="M22.9992 12.0084C22.9992 15.9252 19.8326 19.1006 15.9263 19.1006C14.2764 19.1006 12.7583 18.534 11.5552 17.5842C13.2004 16.2856 14.2567 14.2708 14.2567 12.0084C14.2567 9.74597 13.2004 7.73119 11.5552 6.43253C12.7583 5.48277 14.2764 4.91618 15.9263 4.91618C19.8326 4.91618 22.9992 8.09151 22.9992 12.0084Z"
      fill="#F99F1B"
    />
  </svg>
</template>
